import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment from 'moment';

@Component({
    selector: 'app-cash-payment',
    templateUrl: './cash-payment.component.html',
    styleUrls: ['./cash-payment.component.css']
})
export class CashPaymentComponent implements OnInit {
    ItemList = [];
    keyval: any;

    PaymentModelSearch = {
        AccID: 0,
        FromDate: moment(new Date()).format("DD-MMM-YYYY"),
        ToDate: moment(new Date()).format("DD-MMM-YYYY"),
        ChequeNo: '',
        Narration: '',
        Print: "",
        AccName: ""
    };
    PaymentModel = {
        TransDetID: 0,
        CreditAccID: 0,
        DebitAccID: 0,
        Amount: 0,
        AccID: 0,
        IsChequeName: false,
        IsChqExist: false,
        DebitAmount: 0,
        Narration: '',
        ChequeDate: moment(new Date()).format("DD-MMM-YYYY"),
        ChequeNo: '',
        ChequeName: '',
        CreditNarration: '',
        DebitNarration: '',
        TotalDebitAmt: 0,
        TransID: 0,
        TransDate: moment(new Date()).format("DD-MMM-YYYY"),
    };
    ItemListAll: any;
    AccCode = '';
    AccName = '';
    CashAccName = '';
    Submitted = false;
    IsChqExist = false;
    ExceedMsg = '';
    constructor(private accService: AccountingService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) { }

    getkeys(event) {
        this.keyval = event.keyCode;
        if (this.keyval == 13) {
            this.Add();
        }
    }

    // this.PaymentModel = {
    //     CreditAccID: 0,
    //     DebitAccID: 0,
    //     Amount: 0,
    //     IsChequeName: false,
    //     ChequeName: '',
    //     DebitAmount: 0,
    //     CreditNarration: '',
    //     DebitNarration: '',
    //     TotalDebitAmt: 0,
    //     TransDate: $filter('date')(new Date(), 'dd-MMM-yyyy'),
    // };
    Edit(item) {
        this.PaymentModel.TransDate = moment(new Date(item.TransDate)).format("DD-MMM-YYYY");
        this.PaymentModel.ChequeNo = item.ChequeNo;
        this.PaymentModel.ChequeDate = moment(new Date(item.ChequeDate)).format("DD-MMM-YYYY");
        this.PaymentModel.ChequeName = item.ChequeName;
        this.PaymentModel.IsChequeName = item.IsChequeName;
        this.PaymentModel.CreditAccID = item.CreditAccID;
        this.PaymentModel.Amount = item.Amount;
        this.PaymentModel.Narration = item.Narration;
        this.PaymentModel.TransID = item.TransID;
        this.spinnerService.show();
        this.ItemList = [];
        this.accService.GetCashPaymentVoucherDetails(this.PaymentModel.TransID).subscribe((response) => {
            this.ItemListAll = response.JournaVoucherDetailsList;
            this.spinnerService.hide();
            setTimeout(() => {

                this.globalHelper.CheckActionStatus(response);
                for (var i = 0; i < this.ItemListAll.length; i++) {
                    if (this.ItemListAll[i].DebitAmt > 0) {
                        var itembo = {
                            TransDetID: this.ItemListAll[i].TransDetID,
                            AccID: this.ItemListAll[i].AccID,
                            AccName: this.ItemListAll[i].AccName,
                            AccCode: this.ItemListAll[i].AccCode,
                            Amount: this.ItemListAll[i].DebitAmt,
                            Narration: this.ItemListAll[i].Narration,
                        }
                        this.AccName = this.ItemListAll[i].AccName;
                        this.ItemList.push(itembo)
                    }
                    else {
                        this.CashAccName = this.ItemListAll[i].AccName;
                        this.PaymentModel.CreditAccID = this.ItemListAll[i].AccID;
                        this.PaymentModel.Amount = this.ItemListAll[i].Amount;
                        this.PaymentModel.TransDetID = this.ItemListAll[i].TransDetID;
                        this.PaymentModel.TransDate = moment(new Date(this.ItemListAll[i].TransDate)).format("DD-MMM-YYYY");
                    }
                    //this.ItemListAll[i].Amount = this.ItemListAll[i].DebitAmt > 0 ? this.ItemListAll[i].DebitAmt : this.ItemListAll[i].CreditAmt;
                }
                if (this.AccName != this.PaymentModel.ChequeName) {
                    this.PaymentModel.IsChequeName = true;
                }


                this.SumTotalAmount();
            }, 10);

        });

    }


    Submitted1 = false;

    Clear() {
        this.PaymentModel.CreditAccID = 0;
        this.PaymentModel.DebitAccID = 0;
        this.PaymentModel.Amount = 0;
        this.AccCode = '';
        this.AccName = '';
        this.PaymentModel.ChequeName = '';
        this.PaymentModel.IsChequeName = false;
        this.PaymentModel.Narration = '';
        this.PaymentModel.DebitNarration = '';
        this.PaymentModel.DebitAmount = 0;
        this.CashAccName = '';
        this.Submitted = false;

    };
    SearchCashAccName = '';
    ClearSearch() {
        this.PaymentModelSearch.AccID = 0;
        this.PaymentModelSearch.FromDate = '';
        this.PaymentModelSearch.ToDate = '';
        this.SearchCashAccName = '';
    };


    onSelect($item) {
        this.AccName = $item.AccName;
        this.PaymentModel.DebitAccID = $item.AccID;
    }

    onSelectName($item) {
        this.AccCode = $item.AccCode;
        this.PaymentModel.DebitAccID = $item.AccID;
        this.PaymentModel.AccID = $item.AccID;
    }

    onSelectCash($item) {
        this.PaymentModel.CreditAccID = $item.ItemId;
    }

    onSelectCashSearch($item) {
        this.PaymentModelSearch.AccID = $item.ItemId;
    }

    ValidateAdd() {
        return this.PaymentModel.AccID == 0 || this.PaymentModel.DebitNarration == '' || this.PaymentModel.CreditAccID == 0;
    };
    Add() {
        this.Submitted = true;
        this.Submitted1 = true;
        this.ExceedMsg = "";
        if (!this.ValidateAdd()) {
            this.Submitted = false;
            this.Submitted1 = false;
            var itembo = {
                AccName: this.AccName,
                AccCode: this.AccCode,
                AccID: this.PaymentModel.DebitAccID,
                Amount: this.PaymentModel.DebitAmount,
                Narration: this.PaymentModel.DebitNarration,
            }

            if (this.PaymentModel.IsChequeName == false) {
                this.PaymentModel.ChequeName = this.AccName;
            }
            if (true) {
                this.AccCode = "";
                this.AccName = "";
                this.PaymentModel.DebitAmount = 0;
                this.PaymentModel.DebitNarration = '';
                this.ItemList.push(itembo);
                this.SumTotalAmount();
            }


        }


    }

    removeRow(index) {
        this.ItemList.splice(index, 1);
        this.SumTotalAmount();

    };

    SumTotalAmount() {
        var TotalDebitAmt = 0;
        for (var i = 0; i < this.ItemList.length; i++) {
            TotalDebitAmt = TotalDebitAmt + parseFloat(this.ItemList[i].Amount);
        }
        this.PaymentModel.TotalDebitAmt = TotalDebitAmt;
        this.PaymentModel.Amount = this.PaymentModel.TotalDebitAmt;
    }



    ValidateDropdownSave() {
        return this.PaymentModel.CreditAccID == 0 || this.PaymentModel.Narration == '' || this.PaymentModel.ChequeName == ''
    };

    loadingSave = false;
    SavePayment() {

        this.Submitted = true;
        if (this.ItemList.length > 0 && this.PaymentModel.IsChequeName == false) {
            this.PaymentModel.ChequeName = this.ItemList[0].AccName;
        }
        if (!this.ValidateDropdownSave()) {
            if (this.PaymentModel.TotalDebitAmt == this.PaymentModel.Amount) {
                this.loadingSave = true;
                this.PaymentModel.TransDate = this.PaymentModel.TransDate != null ? moment(this.PaymentModel.TransDate).format('DD-MMM-YYYY') : '';
                this.accService.SaveCashPayment(JSON.stringify(this.PaymentModel), JSON.stringify(this.ItemList)).subscribe((response) => {
                    setTimeout(() => {

                        this.loadingSave = false;
                    }, 10);

                    if (response.webResponse.Status) {
                        this.Clear();
                        this.ItemList = [];
                        this.GetCashPayment();
                        this.globalHelper.CheckActionStatus(response);
                    }
                });
            }
        }
    }



    // SavePayment  () {

    //     this.Submitted = true;
    //     if (this.ItemList.length > 0 && this.PaymentModel.IsChequeName == false) {
    //         this.PaymentModel.ChequeName = this.ItemList[0].AccName;
    //     }
    //     if (!ValidateDropdownSave()) {
    //         if (this.PaymentModel.TotalDebitAmt == this.PaymentModel.Amount) {
    //             this.loadingSave = true;

    //            this.accService.SaveCashPayment(JSON.stringify(this.PaymentModel), JSON.stringify(this.ItemList)).subscribe( (response)=> {
    //                  setTimeout( ()=> {

    //                     this.loadingSave = false;
    //                 }, 10);

    //                 if (response.webResponse.Status) {
    //                     this.Clear();
    //                     this.ItemList = [];
    //                     this.GetCashPayment();
    //                     this.globalHelper.CheckActionStatus(response);
    //                 }
    //             });
    //         }
    //     }
    // }
    loadingSearch = false;
    CashpaymentList: any;
    GetCashPayment() {
        this.loadingSearch = true;
        this.PaymentModelSearch.FromDate = this.PaymentModelSearch.FromDate != null && this.PaymentModelSearch.FromDate != '' ? moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY') : '';
        this.PaymentModelSearch.ToDate = this.PaymentModelSearch.ToDate != null && this.PaymentModelSearch.ToDate!='' ? moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY') : '';
        this.spinnerService.show();
        this.accService.GetCashPayment(JSON.stringify(this.PaymentModelSearch)).subscribe((response) => {
            this.CashpaymentList = response.CashpaymentList;
            this.spinnerService.hide();
            setTimeout(() => {

                this.loadingSearch = false;
                this.globalHelper.CheckActionStatus(response);
            }, 10);

        });
    };

    //this.Edit  (obj) {
    //    this.BookModel.BookID = obj.BookID;
    //    this.BookModel.BookName = obj.BookName;
    //};            



    // Look UP
    AccountList: any;
    GetAccount() {
        this.lookupService.GetLookupsList('Acc', '').subscribe((data) => {
            this.AccountList = data.LookupItems;
            this.AccountList.splice(0, 1);
        });
    };
    CashAccountList: any;
    GetCashAccount() {

        this.lookupService.GetLookupsList('CashAcc', '').subscribe((data) => {
            this.CashAccountList = data.LookupItems;
            this.CashAccountList.splice(0, 1);
        });
    }


    // Print

    PrintList() {
        this.PaymentModelSearch.Print = 'P';
        this.PaymentModelSearch.FromDate = this.PaymentModelSearch.FromDate != null && this.PaymentModelSearch.FromDate!='' ? moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY') : '';
        this.PaymentModelSearch.ToDate = this.PaymentModelSearch.ToDate != null && this.PaymentModelSearch.ToDate != '' ? moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY') : '';
       
        var url = "cashpaymentprint?ReportType=PrintCashPayment&FromDate=" + this.PaymentModelSearch.FromDate + "&ToDate=" + this.PaymentModelSearch.ToDate + "&Print=" + this.PaymentModelSearch.Print;
        this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");

    };
    Print = 'P';
    TransID = 0;

    GetVoucherPrint(item) {
        this.Print = 'P';
        this.TransID = item.TransID;
        this.TransID = item.TransID;
        var url = "cashpaymentvoucherprint?ReportType=PrintCashReceipt&TransID=" + this.TransID;
        this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
    }
    TotalDebitAmt = 0;
    TotalCreditAmt = 0;

    Views = {
        TransDate: "",
        Cancel:"",
        CancelRemarks:"",
    }
    VoucherNo = "";
    TransType = "";
    JournaVoucherDetailsList: any;
    GetVoucherDetails(item) {
        this.TotalDebitAmt = item.Amount;
        this.TotalCreditAmt = item.Amount;
        this.Views.TransDate = item.CreatedOn;
        this.Views.Cancel = item.Cancel;
        this.Views.CancelRemarks = item.CancelRemarks;
        this.TransID = item.TransID;
        this.VoucherNo = item.VoucherNo;
        this.TransType = item.TransType;

        this.accService.GetCashPaymentVoucherDetails(this.TransID).subscribe((response) => {
            this.JournaVoucherDetailsList = response.JournaVoucherDetailsList;
            setTimeout(() => {


                this.globalHelper.CheckActionStatus(response);
            }, 10);
        });

    }
    TransDate:any;
    GetVoucherCancel  (item) {
        this.submitCancel = false;
       
        this.CancelModel.TransID = item.TransID;

        this.TransDate = item.CreatedOn;
        this.TransID = item.TransID;
        this.VoucherNo = item.VoucherNo;
        this.TransType = item.TransType;
    }
    loadingCancel = false;
    CancelModel = {
        CancelRemarks: '',
        TransID: 0,
    }
    submitCancel = false;
    CancelVoucher  () {
        this.submitCancel = true;
        if (this.CancelModel.CancelRemarks != '') {

            this.loadingCancel = true;
            this.submitCancel = false;
            this.accService.CancelVoucher(JSON.stringify(this.CancelModel)).subscribe((response) => {
                this.globalHelper.CheckActionStatus(response);
                this.GetCashPayment();

                if(response.webResponse.Status){
                    this.CancelModel = {
                        CancelRemarks: '',
                        TransID: 0,
                    }
                }
              
                this.loadingCancel = false;
                
            });
          
         
        }

    }
    ngOnInit() {
        setTimeout(() => {
     
            this.PaymentModelSearch.FromDate = moment(this.globalHelper.GetLoginToken().SessionStartDate).format("DD-MMM-YYYY");
      
            this.PaymentModelSearch.ToDate = moment(this.globalHelper.GetLoginToken().SessionEndDate).format("DD-MMM-YYYY");
                       
          }, 300);
        this.GetAccount();
        this.GetCashAccount();
    }

}
